import clsx from 'clsx';
import styles from './KPIStrip.module.css';

export interface KpiItem {
  key: string;
  label: string;
  value: string;
  /** Small muted suffix after the value (e.g. "%" or "млн ₽"). */
  suffix?: string;
  tone?: 'default' | 'negative' | 'muted';
  /** Native tooltip explaining how the metric is derived. */
  hint?: string;
}

export interface KPIStripProps {
  items: KpiItem[];
  ariaLabel?: string;
}

/**
 * Summary KPI strip for the report dashboard — restrained single row of
 * mono numbers divided by hairlines (Board language).
 */
export function KPIStrip({ items, ariaLabel }: KPIStripProps) {
  return (
    <div className={styles.strip} aria-label={ariaLabel}>
      {items.map((item) => (
        <div className={styles.kpi} key={item.key} title={item.hint}>
          <span className={styles.label}>{item.label}</span>
          <span
            className={clsx(
              styles.value,
              item.tone === 'negative' && styles.negative,
              item.tone === 'muted' && styles.muted,
            )}
          >
            {item.value}
            {item.suffix && <small className={styles.suffix}>{item.suffix}</small>}
          </span>
        </div>
      ))}
    </div>
  );
}
